export const KeyboardActions = Object.freeze({
  ENTER: 13,
  ARROW_UP: 38,
  ARROW_DOWN: 40,
});
